import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseSectionService } from '../../services/course-section.service';

@Component({
  selector: 'app-course-register',
  templateUrl: './course-register.component.html',
  styleUrls: ['./course-register.component.scss']
})
export class CourseRegisterComponent implements OnInit {

  courseId!: string;
  selectedCourse: any;
  registeredUsers: any[] = [];
  limit: number = 5;
  offset = 0;
  loading = false;
  allLoaded = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private router: Router,
    private CourseSectionService: CourseSectionService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.loadCourseAndUsers();
    this.loadRegisteredUsers();
  }

  loadCourseAndUsers(): void {
    this.activeRoute.params.subscribe((params) => {
      this.courseId = params['id'];

      this.CourseSectionService.getRegCourseById(this.courseId).subscribe((data: any) => {
        this.selectedCourse = data;
      });
    });
  }

  loadRegisteredUsers(): void {
    if (this.loading || this.allLoaded) return;

    this.loading = true;

    this.CourseSectionService.getCourseRegisteredUsers(this.courseId, this.limit, this.offset)
      .subscribe((users) => {

        if (!users || users.length === 0) {
          this.allLoaded = true;
        } else {
          this.registeredUsers = [...this.registeredUsers, ...users];
          console.log('registeredUsers----------------------', this.registeredUsers)
          this.offset += this.limit;

          //  If  users returned than the limit, no more data left
          if (users.length < this.limit) {
            this.allLoaded = true;
          }
        }

        this.loading = false;
      }, () => {
        this.loading = false;
      });
  }


  onScroll(): void {
    this.loadRegisteredUsers();
  }
}



